import {
  ArrowsClockwise,
  ArrowUpRight,
  LinkedinLogo,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";

import DetailItem from "./DetailItem";

interface LinkedInRowProps {
  isLoggedIn: boolean;
  isSyncingAccount: boolean;
  publicIdentifier: string;
  onSync: () => void;
}

export default function LinkedInRow({
  isLoggedIn,
  isSyncingAccount,
  publicIdentifier,
  onSync,
}: LinkedInRowProps) {
  return (
    <DetailItem label="LinkedIn" icon={<LinkedinLogo weight="fill" />}>
      <div className="flex">
        <RenderIf condition={isLoggedIn}>
          <Button
            rightIcon={
              <ArrowsClockwise className={isSyncingAccount && "animate-spin"} />
            }
            disabled={isSyncingAccount}
            variant="link-purple"
            size="sm"
            onClick={onSync}
          >
            Sync
          </Button>
        </RenderIf>

        <div className="mx-1.5 w-px bg-black-200" />

        <Button
          rightIcon={<ArrowUpRight />}
          variant="link-purple"
          size="sm"
          asChild
        >
          <Link
            target="_blank"
            to={`https://linkedin.com/in/${publicIdentifier}`}
            rel="noreferrer"
          >
            View profile
          </Link>
        </Button>
      </div>
    </DetailItem>
  );
}
